import React, { useEffect, useState, useRef } from "react";
import { FULL_API_BASE_URL } from "../../Config/Config";
import DropDown from "../AssignTest/Dropdown";
import InputField from "../AssignTest/FormInputs";
import Swal from "sweetalert2";
import DrodownSelection from "./DrodownSelection";
import "./quespapercorrection.css";
import { MdDelete } from "react-icons/md";
import Papa from "papaparse";

function QuestionPaperCorrection(dataClient) {
  const [courses, setCourses] = useState([]);
  const [courseOpted, setCourseOpted] = useState("");
  const [assessments, setAssessments] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [detailedAssessment, setDetailedAssessment] = useState(null);
  const [selectedSets, setSelectedSets] = useState([]);
  const [dropdownKey, setDropdownKey] = useState(Date.now());
  const [corrections, setCorrections] = useState([{ id: 1 }]);
  const [selectedQuestionNumbers, setSelectedQuestionNumbers] = useState([]);
  const filterRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const user_name = dataClient?.dataClient?.client_schema_name[6][0].user_name;

  // =========================================================================
  const [selectedSet, setSelectedSet] = useState("1");
  const [uploadedData, setUploadedData] = useState({});
  const [currentSetQuestions, setCurrentSetQuestions] = useState([]);
  // const [testDetails, setTestDetails] = useState({
  //   mode: "",
  //   testDuration: "",
  //   questions: "",
  //   optionalQuestions: "",
  //   testId: "",
  //   description: "",
  //   numberOfSets: 1,
  //   sections: [],
  // });
  const [file, setFile] = useState(null);
  const [correctOptionTypeNumeric, setCorrectOptionTypeNumeric] =
    useState(false);

  const [uploadSectionOpen, setUploadSectionOpen] = useState(true);
  const [addCorrectionsOpen, setAddCorrectionsOpen] = useState(true);

  let choice_int = 0;
  let upload_question_count = 0;
  let database_question_count = 0;

  const setMap = { A: "1", B: "2", C: "3", D: "4", E: "5" };

  const answerMap = {
    A: 1,
    B: 2,
    C: 3,
    D: 4,
    E: 5,
    a: 1,
    b: 2,
    c: 3,
    d: 4,
    e: 5,
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
  };

  const reverseAnswerMap = {
    1: "A",
    2: "B",
    3: "C",
    4: "D",
    5: "E",
    0: "0",
  };

  const getSetLabel = (setNumber) => {
    return String.fromCharCode(64 + parseInt(setNumber)); // Convert 1 -> A, 2 -> B, etc.
  };

  const handleSetChange = (event) => {
    const newSelectedSet = event.target.value;
    setSelectedSet(newSelectedSet);

    if (uploadedData[newSelectedSet]) {
      setCurrentSetQuestions(uploadedData[newSelectedSet]);
    } else {
      setCurrentSetQuestions([]);
    }
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // =========================================================================
  // const handleUpload = () => {
  //   if (!file) {
  //     console.error("No file selected!");
  //     return;
  //   }
  //   if (!selectedSet) {
  //     console.error("No set selected!");
  //     return;
  //   }

  //   Papa.parse(file, {
  //     header: true,
  //     skipEmptyLines: true,
  //     complete: function (results) {
  //       if (results.errors.length) {
  //         console.error("Errors parsing CSV:", results.errors);
  //         return;
  //       }

  //       const data = results.data;
  //       if (!isNaN(data[0].Key)) {
  //         setCorrectOptionTypeNumeric(true);
  //       }

  //       const formattedData = data.map((item, index) => {
  //         const keys = Object.keys(item);
  //         const question = item[keys[0]];
  //         const correct_ans = item[keys[1]];
  //         const numeric = item[keys[2]];

  //         const answers = correct_ans
  //           ? correct_ans.split(/[,|]/).map((ans) => ans.trim())
  //           : ["0"];

  //         let numeric_answer =
  //           numeric !== undefined && numeric !== null ? numeric : null;

  //         let correct_option = answers.map((answer) => {
  //           if (answerMap[answer] !== undefined) {
  //             return answerMap[answer];
  //           } else if (!isNaN(answer)) {
  //             return parseInt(answer, 10); // Ensure number format is handled
  //           } else {
  //             return 0;
  //           }
  //         });

  //         if (numeric_answer !== null) {
  //           numeric_answer = numeric_answer
  //             .replace(/^0+([1-9])/, "$1")
  //             .replace(/^0+([.])/, "$1")
  //             .replace(/^0+(\.\d+)/, "$1");
  //         }

  //         if (numeric_answer === null && correct_option.includes(0)) {
  //           numeric_answer = "0";
  //         }

  //         return {
  //           set: selectedSet,
  //           question_no: index + 1,
  //           correct_option:
  //             correct_option.length > 0 ? correct_option.map(Number) : [0],
  //           numeric_answer: numeric_answer ? numeric_answer : null,
  //         };
  //       });

  //       setUploadedData((prev) => ({
  //         ...prev,
  //         [selectedSet]: formattedData,
  //         ques_ans_details: [
  //           ...(prev.ques_ans_details || []),
  //           ...formattedData,
  //         ],
  //       }));

  //       setCurrentSetQuestions(formattedData);
  //     },
  //   });
  // };

  const handleUpload = () => {
    if (!file) {
      console.error("No file selected!");
      return;
    }
    if (!selectedSet) {
      console.error("No set selected!");
      return;
    }

    // let temp_quest_number = 0

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        if (results.errors.length) {
          console.error("Errors parsing CSV:", results.errors);
          return;
        }

        const data = results.data;
        if (!isNaN(data[0].Key)) {
          setCorrectOptionTypeNumeric(true);
        }

        const formattedData = data.flatMap((item, index) => {
          const keys = Object.keys(item);
          const question = item[keys[0]];
          const correct_ans = item[keys[1]];
          const numeric = item[keys[2]];

          // temp_quest_number = parseInt(question);

          const answers = correct_ans
            ? correct_ans.split(/[,|]/).map((ans) => ans.trim())
            : ["0"];

          let numeric_answer =
            numeric !== undefined && numeric !== null ? numeric : null;

          let correct_option = answers.map((answer) => {
            if (answerMap[answer] !== undefined) {
              return answerMap[answer];
            } else if (!isNaN(answer)) {
              return parseInt(answer, 10); // Ensure number format is handled
            } else {
              return 0;
            }
          });

          if (numeric_answer !== null) {
            numeric_answer = numeric_answer
              .replace(/^0+([1-9])/, "$1")
              .replace(/^0+([.])/, "$1")
              .replace(/^0+(\.\d+)/, "$1");
          }

          if (numeric_answer === null && correct_option.includes(0)) {
            numeric_answer = "0";
          }

          return correct_option.map((option) => ({
            set: selectedSet,
            question_no: index + 1,
            correct_option: [option],
            numeric_answer: numeric_answer ? numeric_answer : null,
          }));
        });

        setUploadedData((prev) => ({
          ...prev,
          [selectedSet]: formattedData,
        }));

        setCurrentSetQuestions(formattedData);
      },
    });
    // console.log("UploadedData", currentSetQuestions[currentSetQuestions.length-1].question_no)
  };
  if (currentSetQuestions.length > 0) {
    upload_question_count =
      currentSetQuestions[currentSetQuestions.length - 1].question_no;
  } else {
    upload_question_count = 0;
  }

  useEffect(() => {
    const fetchCourses = async () => {
      const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`);
      const data = await response.json();
      setCourses(data);
    };

    fetchCourses();
  }, []);

  useEffect(() => {
    if (searchKey.trim().length === 0) {
      setAssessments([]);
    } else {
      fetchData();
    }
  }, [searchKey]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (filterRef.current && !filterRef.current.contains(event.target)) {
      setAssessments([]);
    }
  };

  const fetchData = async () => {
    const clientBranchId =
      dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
    const assessment_type_id = 2;

    const response = await fetch(
      `${FULL_API_BASE_URL}/get-assessment-names/?assessment_type_id=${assessment_type_id}&course_id=${courseOpted}&client_branch_id=${clientBranchId}&search_key=${searchKey}`
    );
    const data = await response.json();

    if (data.data && data.data.length > 0) {
      setAssessments(data.data);
    } else {
      setAssessments([]);
      console.log("No tests found for the selected course.");
    }
  };

  const handleAssessmentClick = (item) => {
    setSelectedAssessment(item);
    setSearchKey(item.assessment_name);
    setAssessments([]);
    setSelectedQuestionNumbers([]);
    setSelectedSets([]);
    fetchDetailedAssessment(item.assessment_id);
  };

  const fetchDetailedAssessment = async (assessmentId) => {
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-tests-questions/?assessment_id=${assessmentId}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch detailed assessment data");
      }
      const data = await response.json();
      setDetailedAssessment(data);
    } catch (error) {
      console.error("Error fetching detailed assessment data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to fetch detailed assessment data",
      });
    }
  };

  const QuestionNumber =
    detailedAssessment &&
    detailedAssessment.data &&
    detailedAssessment.data.length > 0
      ? detailedAssessment.data[0].test_questions.map((question, index) => ({
          label: `Question ${question.ques_no}`,
          id: question.ques_no,
        }))
      : [];

  if (detailedAssessment) {
    // console.log(
    //   "deass",
    //   detailedAssessment.data[0].test_questions[
    //     detailedAssessment.data[0].test_questions.length - 1
    //   ].ques_no
    // );
    database_question_count =
      detailedAssessment.data[0].test_questions[
        detailedAssessment.data[0].test_questions.length - 1
      ].ques_no;
    // console.log("database",database_question_count)
  }

  const QuestionSets =
    detailedAssessment &&
    detailedAssessment.data &&
    detailedAssessment.data.length > 0
      ? detailedAssessment.data[0].test_questions.reduce((uniqueSets, set) => {
          const existingSetIndex = uniqueSets.findIndex(
            (s) => s.label === set.set
          );
          if (existingSetIndex === -1) {
            uniqueSets.push({
              label: set.set,
              id: set.set,
            });
          }
          return uniqueSets;
        }, [])
      : [];

  // {
  //   QuestionSets.length == 0 ? console.log("QuestionSets is empty"):console.log("QuestionSets", QuestionSets.length);

  // }

  const Options = QuestionSets.map((set) => ({
    label:
      set.label === "1"
        ? "A"
        : set.label === "2"
        ? "B"
        : set.label === "3"
        ? "C"
        : set.label,
    id: set.id,
  }));

  const addCorrectionSet = () => {
    const newId = corrections.length + 1;
    setCorrections([...corrections, { id: newId }]);
  };

  // const handleSave = async () => {
  //   try {
  //     const savePromises = [];

  //     for (let i = 0; i < corrections.length; i++) {
  //       const selectedQuestionNumber = selectedQuestionNumbers[i] || null;
  //       const selectedSet = selectedSets[i] || null;
  //       const correction = corrections[i];

  //       if (addCorrectionsOpen && uploadSectionOpen) {
  //         choice_int = 3;
  //       } else if (addCorrectionsOpen) {
  //         choice_int = 1;
  //       } else if (uploadSectionOpen) {
  //         choice_int = 2;
  //       }

  //       let url = `http://127.0.0.1:8000/coaching-collaborator-api/api/v1/test-marks-correction-v2?assessment_id=${selectedAssessment.assessment_id}&choice_int=${choice_int}`;

  //       const requestBody = uploadedData[1] || [];

  //       // console.log("up data",uploadedData[1])

  //       console.log("url", url);
  //       console.log("requestBody", requestBody);

  //       const savePromise = fetch(url, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestBody),
  //       });

  //       savePromises.push(savePromise);
  //     }

  //     await Promise.all(savePromises);
  //     Swal.fire({
  //       icon: "success",
  //       title: "Success",
  //       text: "All corrections saved successfully",
  //     });
  //   } catch (error) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text: "Failed to save corrections",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //   }
  // };

  // const handleSave = async () => {
  //   try {
  //     const savePromises = [];
  //     let requestBodyNew = [];

  //     for (let set in uploadedData) {
  //       if (set !== "ques_ans_details") {
  //         const setData = uploadedData[set].map((item) => ({
  //           set: item.set,
  //           question_no: parseInt(item.question_no),
  //           correct_option: item.correct_option,
  //           numeric_answer: item.numeric_answer,
  //         }));
  //         requestBodyNew = requestBodyNew.concat(setData);
  //       }
  //     }
  //     // console.log("quesAnsDetails",quesAnsDetails)

  //     // if (requestBodyNew.length === 0) {
  //     //   Swal.fire({
  //     //     icon: "error",
  //     //     title: "Error",
  //     //     text: "The request body is empty. Please upload the correct data.",
  //     //     confirmButtonColor: "rgb(100 101 101)",
  //     //   });
  //     //   return;
  //     // }

  //     for (let i = 0; i < corrections.length; i++) {
  //       const selectedQuestionNumber = selectedQuestionNumbers[i] || null;
  //       const selectedSet = selectedSets[i] || null;
  //       const correction = corrections[i];

  //       if (addCorrectionsOpen && uploadSectionOpen) {
  //         choice_int = 3;
  //       } else if (addCorrectionsOpen) {
  //         choice_int = 1;
  //       } else if (uploadSectionOpen) {
  //         choice_int = 2;
  //       }

  //       console.log("choice_int", choice_int);

  //       let url =
  //         choice_int == 2
  //           ? `http://127.0.0.1:8000/coaching-collaborator-api/api/v1/test-marks-correction-v2?assessment_id=${selectedAssessment.assessment_id}&choice_int=${choice_int}`
  //           : `http://127.0.0.1:8000/coaching-collaborator-api/api/v1/test-marks-correction-v2?assessment_id=${selectedAssessment.assessment_id}&set=${selectedSet}&ques_no=${selectedQuestionNumber}&marks=${correction.marks}&reason=${correction.reason}&username=${user_name}&choice_int=${choice_int}`;

  //       // const requestBody = uploadedData[1] || [];

  //       console.log("url", url);
  //       console.log("requestBody", requestBodyNew);

  //       const savePromise = fetch(url, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(requestBodyNew),
  //       });

  //       savePromises.push(savePromise);
  //     }

  //     await Promise.all(savePromises);
  //     Swal.fire({
  //       icon: "success",
  //       title: "Success",
  //       text: "All corrections saved successfully",
  //     }).then(() => {
  //       window.location.reload();
  //     });
  //   } catch (error) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text: "Failed to save corrections",
  //       confirmButtonColor: "rgb(100 101 101)",
  //     });
  //   }
  // };

  const handleSave = async () => {
    console.log("QuestionNumber", QuestionNumber.length);
    try {
      const savePromises = [];
      let requestBodyNew = [];

      for (let set in uploadedData) {
        if (set !== "ques_ans_details") {
          const setData = uploadedData[set].map((item) => ({
            set: item.set,
            question_no: parseInt(item.question_no),
            correct_option: item.correct_option,
            numeric_answer: item.numeric_answer,
          }));
          requestBodyNew = requestBodyNew.concat(setData);
        }
      }
      console.log("compare", requestBodyNew.length);

      for (let i = 0; i < corrections.length; i++) {
        const selectedQuestionNumber = selectedQuestionNumbers[i] || null;
        const selectedSet = selectedSets[i] || null;
        const correction = corrections[i];

        // if (addCorrectionsOpen && uploadSectionOpen) {
        //   choice_int = 3;
        // } else if (addCorrectionsOpen) {
        //   choice_int = 1;
        // } else if (uploadSectionOpen) {
        //   choice_int = 2;
        // }

        if (
          selectedQuestionNumber &&
          selectedSet &&
          correction.marks &&
          correction.reason &&
          requestBodyNew.length === 0
        ) {
          choice_int = 1;
        } else if (
          (!selectedQuestionNumber ||
            !selectedSet ||
            !correction.marks ||
            !correction.reason) &&
          requestBodyNew.length !== 0
        ) {
          choice_int = 2;
        } else if (
          selectedQuestionNumber &&
          selectedSet &&
          correction.marks &&
          correction.reason &&
          requestBodyNew.length !== 0
        ) {
          choice_int = 3;
        }

        if (
          (choice_int == 2 || choice_int == 3) &&
          requestBodyNew.length === 0
        ) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "The request body is empty. Please upload the correct data.",
            confirmButtonColor: "rgb(100 101 101)",
          });
          return;
        } else if (
          (choice_int == 2 || choice_int == 3) &&
          upload_question_count != database_question_count
        ) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: `Uploaded Questions must be equal to ${database_question_count}. Uploaded questions ${upload_question_count}`,
            confirmButtonColor: "rgb(100 101 101)",
          });
          return;
        }

        console.log("choice_int", choice_int);

        // let url =
        //   choice_int == 2
        //     ? `http://127.0.0.1:8000/coaching-collaborator-api/api/v1/test-marks-correction-v2?assessment_id=${selectedAssessment.assessment_id}&choice_int=${choice_int}`
        //     : `http://127.0.0.1:8000/coaching-collaborator-api/api/v1/test-marks-correction-v2?assessment_id=${selectedAssessment.assessment_id}&set=${selectedSet}&ques_no=${selectedQuestionNumber}&marks=${correction.marks}&reason=${correction.reason}&username=${user_name}&choice_int=${choice_int}`;
        let url =
          choice_int == 2
            ? `${FULL_API_BASE_URL}/test-marks-correction-v2?assessment_id=${selectedAssessment.assessment_id}&choice_int=${choice_int}`
            : `${FULL_API_BASE_URL}/test-marks-correction-v2?assessment_id=${selectedAssessment.assessment_id}&set=${selectedSet}&ques_no=${selectedQuestionNumber}&marks=${correction.marks}&reason=${correction.reason}&username=${user_name}&choice_int=${choice_int}`;

        console.log("url", url);
        console.log("requestBody", requestBodyNew);

        const savePromise = fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBodyNew),
        }).then((response) => {
          if (!response.ok) {
            throw new Error(
              `Failed to save correction for set ${selectedSet}, question ${selectedQuestionNumber}.`
            );
          }
          return response.json();
        });

        savePromises.push(savePromise);
      }

      await Promise.all(savePromises);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "All corrections saved successfully",
      });
      // .then(() => {
      //   setTimeout(() => {
      //     window.location.reload();
      //   }, 1000); // Adjust the timeout duration as needed
      // });
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (error) {
      console.error("Error saving corrections:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to save corrections. Please try again.",
        confirmButtonColor: "rgb(100 101 101)",
      });
    }
  };

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  };

  const deleteCorrection = (id) => {
    const updatedCorrections = corrections.filter(
      (correction) => correction.id !== id
    );
    setCorrections(updatedCorrections);
  };

  const handleSearchChange = (e) => {
    setSearchKey(e.target.value);
    if (e.target.value.trim().length > 0) {
      fetchData();
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handleTestSelect = (test) => {
    setSelectedAssessment(test);
    setSearchKey(test.assessment_name);
    setShowDropdown(false);
    fetchDetailedAssessment(test.assessment_id);
  };

  useEffect(() => {
    if (uploadedData["1"]) {
      setCurrentSetQuestions(uploadedData["1"]);
    }
  }, [uploadedData]);

  return (
    <div>
      <div className="create-role-container">
        <div className="create-role-container-one">
          <span className="create-role-heading">Test Paper Correction </span>
          <div className="cr-header-btn-container">
            <button className="cr-cancel-btn" onClick={handleCancel}>
              CANCEL
            </button>
            <button className="cr-create-btn" onClick={handleSave}>
              SAVE
            </button>
          </div>
        </div>
        <div className="personal-info">
          <div className="personal-header">
            <div className="header">
              <h2>SEARCH TEST</h2>
            </div>
          </div>
          <div className="accordion-content" style={{ paddingBottom: "20px" }}>
            <div className="select-test-search-container-ques">
              <DropDown
                label="Course"
                customWidth="250px"
                setSelected={(selectedOption) => {
                  setCourseOpted(selectedOption);
                  setSearchKey("");
                  setDropdownKey(Date.now()); // Update the key to reset dropdowns
                }}
                options={courses.map((course) => ({
                  label: course.course_name,
                  id: course.course_id,
                }))}
                isRequired={true}
              />
              <div className="filter-search-test">
                <input
                  style={{ width: "auto" }}
                  type="text"
                  value={searchKey}
                  onChange={handleSearchChange}
                  placeholder="Search Test"
                />
              </div>
              <div>
                {showDropdown && (
                  <div className="assign-test-list" ref={filterRef}>
                    {assessments.map((test, index) => (
                      <div key={index} onClick={() => handleTestSelect(test)}>
                        <p style={{ padding: "10px" }}>
                          {test.assessment_name}
                        </p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {selectedAssessment && (
              <div className="row-v grey-color-font header-color-dark border-top-bottom-UR">
                <div className="col-1-custom-v">
                  <div className="mb-3-v color424342">Test Name:</div>
                  <div className="mb-3-v color424342">Batch:</div>
                </div>
                <div className="col-v">
                  <div className="mb-3-v color424342">
                    {selectedAssessment.assessment_name}
                  </div>
                  <div className="mb-3-v color424342">
                    {selectedAssessment.batch_name}
                  </div>
                </div>
                <div className="col-1-custom-v">
                  <div className="mb-3-v color424342">Test Date:</div>
                  <div className="mb-3-v color424342">Test Description:</div>
                </div>
                <div className="col-v">
                  <div className="mb-3-v color424342">
                    {new Date(
                      selectedAssessment.assignment_date
                    ).toLocaleString()}
                  </div>
                  <div className="mb-3-v color424342">
                    {selectedAssessment.course_name}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="personal-info">
          <div className="personal-header">
            <div
              className="header"
              style={{ justifyContent: "space-between", width: "100%" }}
            >
              <h2>
                ADD BONUS MARKS
                {/* <button
                  onClick={() => {
                    setAddCorrectionsOpen(!addCorrectionsOpen);
                  }}
                >
                  {addCorrectionsOpen ? "Close" : "Open"}
                </button> */}
              </h2>
              {/* <div
                // style={{ textAlign: "right" }}
                className="accordion-btn"
                // onClick={handleCollapseClick}
                onClick={() => {
                  setAddCorrectionsOpen(!addCorrectionsOpen);
                }}
              >
                {addCorrectionsOpen ? (
                  <div className="minus"></div>
                ) : (
                  <div className="plus">+</div>
                )}
              </div> */}
            </div>
          </div>
          {addCorrectionsOpen && (
            <div className="accordion-content">
              {corrections.map((correction, index) => (
                <div className="question-corrections" key={correction.id}>
                  <DrodownSelection
                    key={`question-dropdown-${dropdownKey}`}
                    label="Select Question"
                    customWidth="250px"
                    setSelected={(selectedOption) => {
                      const newSelectedQuestionNumbers = [
                        ...selectedQuestionNumbers,
                      ];
                      newSelectedQuestionNumbers[index] = selectedOption.id;
                      setSelectedQuestionNumbers(newSelectedQuestionNumbers);
                    }}
                    options={QuestionNumber}
                    isRequired={true}
                    Height="auto"
                    OverFlow="auto"
                    minheight="200px"
                  />
                  <DrodownSelection
                    key={`set-dropdown-${dropdownKey}`}
                    label="Select Set"
                    customWidth="250px"
                    setSelected={(selectedOption) => {
                      const newSelectedSets = [...selectedSets];
                      newSelectedSets[index] = selectedOption.id;
                      setSelectedSets(newSelectedSets);
                    }}
                    options={Options}
                    isRequired={true}
                    Height="auto"
                    OverFlow="auto"
                    minheight="200px"
                  />
                  <InputField
                    label="Marks To Allocate"
                    type="Number"
                    onChange={(e) => {
                      const newCorrections = [...corrections];
                      newCorrections[index].marks = e.target.value;
                      setCorrections(newCorrections);
                    }}
                    required
                  />
                  <InputField
                    label="Reason"
                    type="text"
                    onChange={(e) => {
                      const newCorrections = [...corrections];
                      newCorrections[index].reason = e.target.value;
                      setCorrections(newCorrections);
                    }}
                    required
                  />
                  <div
                    className="accordion-btn"
                    style={{ alignContent: "center", marginTop: "20px" }}
                    onClick={addCorrectionSet}
                  >
                    <div className="plus">+</div>
                  </div>
                  {index > 0 && (
                    <div className="del-corrections">
                      <MdDelete
                        onClick={() => deleteCorrection(correction.id)}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={{ width: "85%" }}>
          <h3
            className="tscr-heading"
            style={{ justifyContent: "space-between" }}
          >
            ADD CORRECTIONS{" "}
            {/* <button
              onClick={() => {
                setUploadSectionOpen(!uploadSectionOpen);
              }}
            >
              {uploadSectionOpen ? "Close" : "Open"}

            </button> */}
            {/* <div
              // style={{ textAlign: "right" }}
              className="accordion-btn"
              // onClick={handleCollapseClick}
              onClick={() => {
                setUploadSectionOpen(!uploadSectionOpen);
              }}
            >
              {uploadSectionOpen ? (
                <div className="minus"></div>
              ) : (
                <div className="plus">+</div>
              )}
            </div> */}
          </h3>
          {uploadSectionOpen && (
            <div className="tscr-bodies tscr-answer-upload">
              {/* <label>Select Set:</label>
              <select
                className="tscr-setselect"
                value={selectedSet}
                onChange={handleSetChange}
              >
                {QuestionSets.length == 0 ? (
                  <option>No Set</option>
                ) : (
                  QuestionSets.map((set) => {
                    <option key={set.id} value={set.id}>
                      Set {getSetLabel(set.id)}
                    </option>;
                  })
                )}
                {QuestionSets.map((set) => {
                  <option key={set.id} value={set.id}>
                    Set {getSetLabel(set.id)}
                  </option>;
                })}
              </select> */}

              <label>Select Set:</label>
              <select
                className="tscr-setselect"
                value={selectedSet}
                onChange={handleSetChange}
              >
                {QuestionSets.length === 0 ? (
                  <option>No Set</option>
                ) : (
                  QuestionSets.map((set) => (
                    <option key={set.id} value={set.id}>
                      Set {getSetLabel(set.id)}
                    </option>
                  ))
                )}
              </select>

              <br />
              <br />
              <input type="file" onChange={handleFileChange} />
              <button
                className="tscr-uploadbtn-TSCR"
                type="button"
                onClick={handleUpload}
              >
                Upload
              </button>
              <br />
              <br />

              {/* {uploadedData.ques_ans_details && currentSetQuestions && (
                <>
                  <h3>Set {getSetLabel(selectedSet)}</h3>
                  <div className="tscr-questanskey">
                    {currentSetQuestions.map((item, index) => (
                      <div key={index} className="tscr-questanskey-sets">
                        {item.correct_option.length === 1 &&
                        item.correct_option[0] === 0 &&
                        item.numeric_answer !== null
                          ? `${item.question_no}: ${item.numeric_answer}`
                          : correctOptionTypeNumeric
                          ? `${item.question_no}: ${item.correct_option}`
                          : `${item.question_no}: ${item.correct_option
                              .map(
                                (option) => reverseAnswerMap[option] || option
                              )
                              .join(", ")}`}
                      </div>
                    ))}
                  </div>
                </>
              )} */}

              {/* {currentSetQuestions && currentSetQuestions.length > 0 && (
                <>
                  <h3>Set {getSetLabel(selectedSet)}</h3>
                  <div className="tscr-questanskey">
                    {currentSetQuestions.map((item, index) => (
                      <div key={index} className="tscr-questanskey-sets">
                        {item.correct_option.length === 1 &&
                        item.correct_option[0] === 0 &&
                        item.numeric_answer !== null
                          ? `${item.question_no}: ${item.numeric_answer}`
                          : correctOptionTypeNumeric
                          ? `${item.question_no}: ${item.correct_option}`
                          : `${item.question_no}: ${item.correct_option
                              .map(
                                (option) => reverseAnswerMap[option] || option
                              )
                              .join(", ")}`}
                      </div>
                    ))}
                  </div>
                </>
              )} */}

              {currentSetQuestions && currentSetQuestions.length > 0 && (
                <>
                  <h3>Set {getSetLabel(selectedSet)}</h3>
                  <div className="tscr-questanskey">
                    {currentSetQuestions.map((item, index) => (
                      <div key={index} className="tscr-questanskey-sets">
                        {item.correct_option.length === 1 &&
                        item.correct_option[0] === 0 &&
                        item.numeric_answer !== null
                          ? `${item.question_no}: ${item.numeric_answer}`
                          : item.correct_option.length > 1
                          ? `${item.question_no}: ${item.correct_option.join(
                              ", "
                            )}`
                          : correctOptionTypeNumeric
                          ? `${item.question_no}: ${item.correct_option}`
                          : `${item.question_no}: ${item.correct_option
                              .map(
                                (option) => reverseAnswerMap[option] || option
                              )
                              .join(", ")}`}
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default QuestionPaperCorrection;

// import React, { useEffect, useState } from "react";
// import "./quespapercorrection.css";
// import BonusQuestionTable from "../../Components/BonusTable/BonusTable";
// import { POST } from "../../Api/HttpsMethods";
// import { GET } from "../../Api/HttpsMethods";
// import EndPoints from "../../Api/EndPoints";
// import DropDown from "../CreateBatch/DropdownCB";
// import ErrorImg from "../../Assets/Images/CommanImages/Error.png";
// import BlankDropdown from "../CreateQuestionsPaper/DppScheduling/BlankDropdown";
// import InputComponent from "../CreateQuestionsPaper/TestScheduling/Input-testscheduling";
// import Colors from "../../Constants/Colors";
// import SearchDropdown from "../../Components/SearchDropdownforListDataSingleSelect/SearchdropdownforlistdataSingleSelect";

// const QuestionPaperCorrection = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const [bonusRows, setBonusRows] = useState([]);
//   const [allQuestions, setAllQuestions] = useState([]);

//   const [courses, setCourses] = useState([]);
//   const [batches, setBatches] = useState([]);
//   const [testOptions, setTestOptions] = useState([]);

//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [selectedBatch, setSelectedBatch] = useState(null);
//   const [selectedTest, setSelectedTest] = useState(null);
//   const [selectedSet, setSelectedSet] = useState(null);

//   // Fetch all courses
//   useEffect(() => {
//     const fetchCourses = async () => {
//       const data = await GET.noToken(EndPoints.GetCourses, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });
//       if (data) setCourses(data);
//     };
//     fetchCourses();
//   }, []);

//   // Fetch batches for selected course
//   useEffect(() => {
//     const fetchBatches = async () => {
//       if (!selectedCourse) return;
//       const url = `${EndPoints.GetBatchByCourse}?course_id=${selectedCourse}`;
//       const data = await GET.noToken(url, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });

//       if (data && Array.isArray(data[0])) setBatches(data[0]);
//       else setBatches([]);

//       setSelectedBatch(null);
//     };
//     fetchBatches();
//   }, [selectedCourse]);

//   // Fetch tests for selected batch
//   useEffect(() => {
//     const fetchTests = async () => {
//       if (!selectedBatch) return;
//       const url = `${EndPoints.GetTestSummarybyBatch}?batch_id=${selectedBatch}`;
//       const response = await GET.withToken(url, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });

//       if (response?.data && Array.isArray(response.data)) {
//         const tests = response.data.map((test) => ({
//           label: test.test_name,
//           id: test.test_schedule_id,
//           ...test,
//         }));
//         setTestOptions(tests);
//       } else {
//         setTestOptions([]);
//       }
//     };
//     fetchTests();
//   }, [selectedBatch]);

//   // Fetch questions for selected test and set
//   useEffect(() => {
//     const fetchQuestionsForSet = async () => {
//       if (!selectedTest?.id || !selectedSet) return;
//       const url = `${EndPoints.GetQuestionsfromSetName}?test_schedule_id=${selectedTest.id}&set_name=${selectedSet}`;
//       const response = await GET.withToken(url, {
//         setMessageBox,
//         setIsMessageBoxVisible,
//         setActiveImg,
//         ErrorImg,
//       });

//       if (response?.status === 200 && Array.isArray(response.data)) {
//         const allQs = response.data
//           .filter((q) => q.ques_number != null)
//           .map((q) => ({
//             id: q.ques_id,
//             ques_number: q.ques_number,
//             ques_text: q.ques_text,
//           }));

//         setAllQuestions(allQs);

//         setBonusRows([
//           {
//             id: Date.now(),
//             questionNo: "",
//             questionText: "",
//             bonusMarks: 0,
//             reason: "Reason to give Bonus Marks",
//             selected: false,
//           },
//         ]);
//       } else {
//         setAllQuestions([]);
//         setBonusRows([]);
//       }
//     };

//     fetchQuestionsForSet();
//   }, [selectedTest, selectedSet]);

//   return (
//     <>
//       <div className="Leftmargin-Main-DIV">
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             marginBottom: "20px",
//             width: "98%",
//           }}
//         >
//           <div
//             style={{
//               fontSize: "30px",
//               color: `${Colors.color1}`,
//               fontWeight: "400",
//             }}
//           >
//             Test Paper Bonus Marks
//           </div>
//           <div>
//             <div className="row-cs-uni">
//               <button
//                 className="create-test-section-btn"
//                 style={{
//                   marginRight: "18px",
//                   boxShadow: `0px 4px 4px 0px ${Colors.color11}`,
//                 }}
//                 onClick={() => {
//                   window.location.reload();
//                 }}
//               >
//                 CANCEL
//               </button>
//               <button
//                 className="create-test-section-btn"
//                 style={{
//                   marginRight: "0px",
//                   boxShadow: `0px 4px 4px 0px ${Colors.color11}`,
//                 }}
//               >
//                 SAVE
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="Header-1-C424342">TEST DETAIL</div>
//         <div className="Body-1-C424342">
//           <div className="row-cs">
//             <div className="col-cs">
//               <DropDown
//                 label="Course"
//                 style={{ width: "100%" }}
//                 setSelected={setSelectedCourse}
//                 options={courses.map((course) => ({
//                   label: course.course_name,
//                   id: course.course_id,
//                 }))}
//                 isRequired={true}
//               />
//             </div>
//             <div className="col-cs">
//               <DropDown
//                 label="Batch"
//                 style={{ width: "100%" }}
//                 setSelected={setSelectedBatch}
//                 options={batches.map((batch) => ({
//                   label: batch.batch_name,
//                   id: batch.batch_id,
//                 }))}
//                 isRequired={true}
//               />
//             </div>
//             <div className="col-cs">
//               {/* <div>test name</div> */}
//               <div style={{ width: "97.5%" }}>
//                 <SearchDropdown
//                   label="Test Name"
//                   initialOptions={testOptions}
//                   selected={selectedTest}
//                   onSelect={(test) => {
//                     setSelectedTest(test);
//                     setSelectedSet(null); // reset set when new test selected
//                   }}
//                   labelKey={(option) => option.label}
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="row-cs">
//             <div className="col-cs3-6">
//               {/* <div>Test Coordinator Name</div> */}
//               <InputComponent
//                 label="Test Coordinator Name"
//                 style={{ width: "100%", marginLeft: "3%" }}
//                 value={selectedTest?.cordinator_name || "-"}
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               {/* <div>Subjects</div> */}
//               <InputComponent
//                 label="Subjects"
//                 style={{ width: "96%", marginLeft: "2.8%" }}
//                 value={
//                   selectedTest?.subjects?.length > 0
//                     ? selectedTest.subjects.join(", ")
//                     : "-"
//                 }
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//           </div>

//           <div className="row-cs">
//             <div className="col-cs">
//               {/* <div>Test Window Start</div> */}
//               <InputComponent
//                 label="Test Window Start"
//                 style={{ width: "100%" }}
//                 value={
//                   selectedTest?.start_date
//                     ? new Date(selectedTest.start_date).toLocaleString()
//                     : "-"
//                 }
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               {/* <div>Test Window End</div> */}
//               <InputComponent
//                 label="Test Window End"
//                 style={{ width: "100%" }}
//                 value={
//                   selectedTest?.end_date
//                     ? new Date(selectedTest.end_date).toLocaleString()
//                     : "-"
//                 }
//                 isRequired={false}
//                 disable={true}
//               />
//             </div>
//             <div className="col-cs">
//               <div></div>
//             </div>
//           </div>
//         </div>

//         <div className="Header-1-C424342" style={{ marginTop: "1.5%" }}>
//           BONUS MARKS
//         </div>
//         <div className="Body-1-C424342">
//           <div className="row-cs" style={{ marginBottom: "1%" }}>
//             <div className="col-cs">
//               {/* <div>Set Name</div> */}
//               <DropDown
//                 label="Set Name"
//                 style={{ width: "100%" }}
//                 setSelected={setSelectedSet}
//                 options={(selectedTest?.set_names || []).map((set) => ({
//                   label: set,
//                   id: set,
//                 }))}
//                 isRequired={true}
//               />
//             </div>
//             <div className="col-cs">
//               <div></div>
//             </div>
//             <div className="col-cs">
//               <div></div>
//             </div>
//           </div>
//           <BonusQuestionTable
//             rows={bonusRows}
//             onChange={setBonusRows}
//             allQuestions={allQuestions}
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// export default QuestionPaperCorrection;
